import { CartAddEvent } from '@theme/events';

if (!customElements.get('mm-membership-button')) {
  /**
   * Adds the annual membership (with its Appstle selling plan) to the cart,
   * then lets the cart drawer re-render through the theme's CartAddEvent.
   */
  class MembershipButton extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#add);
      this.addEventListener('keydown', this.#onKeyDown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#add);
      this.removeEventListener('keydown', this.#onKeyDown);
    }

    /** @param {KeyboardEvent} event */
    #onKeyDown = (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.#add();
    };

    #add = async () => {
      if (this.getAttribute('aria-busy') === 'true') return;
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: Number(this.dataset.variantId),
                quantity: 1,
                selling_plan: Number(this.dataset.sellingPlanId),
              },
            ],
          }),
        });
        if (!response.ok) throw new Error(`Add to cart failed: ${response.status}`);

        this.dispatchEvent(
          new CartAddEvent({}, 'mm-membership-button', {
            source: 'mm-membership-button',
            itemCount: 1,
            variantId: this.dataset.variantId,
          })
        );
      } catch (error) {
        console.error('[MemberMagic] could not add membership', error);
        this.removeAttribute('aria-busy');
      }
    };
  }

  customElements.define('mm-membership-button', MembershipButton);

  // Back/forward cache (iOS Safari): a restored page keeps the button busy from
  // the earlier tap, and a busy button ignores every tap after it.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('mm-membership-button[aria-busy="true"]').forEach((button) => {
      button.removeAttribute('aria-busy');
    });
  });
}
